import { FC, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { CustomButton, LabelAndValue } from '@medtronic/pecc-react-component-library-js';
import { Box, Modal, Stack, Typography } from '@mui/material';
import { User } from '~/api/types';
import { ModalHeader } from '~/components';
import { modalActionBlockStyles } from '~/components/styles';
import { removeButtonStyles, removeUserModalContainerStyles } from './styles';

interface RemoveUserModalProps {
  user: User | null;
  open: boolean;
  onClose: () => void;
  onRemove: () => void;
}

const RemoveUserModal: FC<RemoveUserModalProps> = ({ user, open, onClose, onRemove }) => {
  const { watch } = useFormContext();
  const dataUploaders = watch('data_uploaders');
  const secondaryDataOwners = watch('secondary_data_owners');

  const modalConfig = useMemo(() => {
    if (!user) return null;
    else if (dataUploaders.includes(user.id)) {
      return {
        role: 'Data Uploader',
        roleLabel: 'Data Uploader',
      };
    } else if (secondaryDataOwners.includes(user.id)) {
      return {
        role: 'Data Steward',
        roleLabel: 'Secondary Data Steward',
      };
    }

    return null;
  }, [user, secondaryDataOwners, dataUploaders]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={removeUserModalContainerStyles}>
        <ModalHeader onClose={onClose} title={[`Remove ${modalConfig?.role}`]} />
        <Stack p={1}>
          <LabelAndValue label={modalConfig?.roleLabel} value={user ? `${user.first_name} ${user.last_name}` : '—'} />
          <Typography
            p={2}
          >{`Are you sure you want to remove the ${modalConfig?.role.toLowerCase()}? Please confirm how you would like to proceed.`}</Typography>
        </Stack>
        <Box sx={modalActionBlockStyles}>
          <CustomButton buttonType="borderless" label="Keep" type="button" onClick={onClose} />
          <CustomButton sx={removeButtonStyles} label="Remove" onClick={onRemove} />
        </Box>
      </Box>
    </Modal>
  );
};

export default RemoveUserModal;
